import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_textarea = _resolveComponent("the-textarea")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "medium",
    title: "Редактирование шаблона WABA",
    loading: _ctx.state.is_loading,
    onCancel: _ctx.closeModal,
    onConfirm: _ctx.updateTemplate
  }, {
    default: _withCtx(() => [
      _createVNode(_component_the_input, {
        placeholder: "Название шаблона",
        value: _ctx.state.name,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.name) = $event)),
        disabled: _ctx.state.is_loading,
        "is-invalid": _ctx.state_form$.name.$error,
        "validation-errors": _ctx.state_form$.name.$errors
      }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_textarea, {
        class: "mt-2",
        placeholder: "Текст шаблона",
        value: _ctx.state.text,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.text) = $event)),
        autoheight: "",
        disabled: _ctx.state.is_loading,
        "is-invalid": _ctx.state_form$.text.$error,
        "validation-errors": _ctx.state_form$.text.$errors
      }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_select, {
        class: "mt-4",
        value: _ctx.state.language,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.language) = $event)),
        placeholder: "Выберите язык",
        options: _ctx.data_state.languages.list,
        searchable: false,
        disabled: _ctx.state.is_loading,
        loading: _ctx.data_state.languages.is_loading,
        failed: _ctx.data_state.languages.is_failed,
        "is-invalid": _ctx.state_form$.language.$error,
        "validation-errors": _ctx.state_form$.language.$errors,
        label: "label",
        "select-by": "value",
        onRefresh: _ctx.loadLanguages
      }, null, 8, ["value", "options", "disabled", "loading", "failed", "is-invalid", "validation-errors", "onRefresh"]),
      _createVNode(_component_the_select, {
        class: "mt-4",
        value: _ctx.state.category,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.category) = $event)),
        placeholder: "Выберите категорию",
        options: _ctx.data_state.categories.list,
        searchable: false,
        disabled: _ctx.state.is_loading,
        loading: _ctx.data_state.categories.is_loading,
        failed: _ctx.data_state.categories.is_failed,
        "is-invalid": _ctx.state_form$.category.$error,
        "validation-errors": _ctx.state_form$.category.$errors,
        label: "label",
        "select-by": "value",
        onRefresh: _ctx.loadCategories
      }, null, 8, ["value", "options", "disabled", "loading", "failed", "is-invalid", "validation-errors", "onRefresh"])
    ]),
    _: 1
  }, 8, ["loading", "onCancel", "onConfirm"]))
}